import React from 'react';
import { CourseCardSkeletonGroup } from '@udemy/react-reveal-components';
const config = {
  compact: {
    cardWidth: '25.6rem',
    imageSize: '6.4rem',
    lineCount: 1
  },
  small: {
    cardWidth: '25.6rem',
    imageSize: '9rem',
    lineCount: 3
  },
  large: {
    cardWidth: '40rem',
    imageSize: '12rem',
    lineCount: 4
  }
};
export const CourseProgressCardsSkeleton = ({
  size = 'small',
  ...skeletonGroupProps
}) => {
  const {
    cardWidth,
    imageSize,
    lineCount
  } = config[size];
  return /*#__PURE__*/React.createElement(CourseCardSkeletonGroup, Object.assign({
    size: "small",
    style: {
      inlineSize: cardWidth,
      maxInlineSize: cardWidth,
      minInlineSize: cardWidth
    },
    imageStyle: {
      inlineSize: imageSize,
      blockSize: imageSize
    },
    lineCount: lineCount
  }, skeletonGroupProps));
};
//# sourceMappingURL=course-progress-cards-skeleton.react-component.js.map